import {
	ChangeDetectionStrategy,
	Component,
	HostBinding,
	Input,
	OnDestroy,
	OnInit,
	ViewEncapsulation,
} from "@angular/core";
import { MatLegacyTableDataSource as MatTableDataSource } from "@angular/material/legacy-table";
import { Jurisdiction } from "@obg/core.config";
import { DialogService } from "@obg/mat.ui.core";
import { TermsAndConditionsConfigService, TermsAndConditionsService, TermsAndConditionsVersion } from "@obg/ngx.common";
import { Subject, Subscription } from "rxjs";
import { takeUntil, tap } from "rxjs/operators";

import { TermsAndConditionsModalContainer } from "../terms-and-conditions-modal/terms-and-conditions-modal.container";

@Component({
	selector: "obg-m-terms-and-conditions-history-container",
	templateUrl: "./terms-and-conditions-history.container.html",
	styleUrls: ["./terms-and-conditions-history.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class TermsAndConditionsHistoryContainer implements OnInit, OnDestroy {
	@HostBinding("class.obg-m-terms-and-conditions-history") class = true;

	@Input() termsAndConditionsDocumentsHistory: TermsAndConditionsVersion[] = [];
	@Input() document: string | undefined;
	@Input() jurisdiction: Jurisdiction | undefined;

	isDownloadLatestAcceptedContentEnabled = this.termsAndConditionsConfigService.isLatestAcceptedContentEnabled();

	dataSource = new MatTableDataSource<TermsAndConditionsVersion>();
	data: { title: string; document: string } | undefined;
	displayedColumns: string[] = ["description", "issuedOn", "acceptedOn", "documentLink"];
	alternativeHeaderJurisdictions: Jurisdiction[] = [Jurisdiction.COGA];

	private destroy$ = new Subject<void>();

	constructor(
		private dialogService: DialogService,
		private termsAndConditionsService: TermsAndConditionsService,
		private termsAndConditionsConfigService: TermsAndConditionsConfigService
	) {}

	ngOnInit(): void {
		this.dataSource.data = this.termsAndConditionsDocumentsHistory.filter((item) => item.isAccepted === true);
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	openModal(termsAndConditionsVersion: TermsAndConditionsVersion) {
		this.dialogService.openComponent(TermsAndConditionsModalContainer, {
			data: { document: this.document, version: termsAndConditionsVersion },
		});
	}

	onDownloadTermsAndConditionsClick(): void {
		this.getLatestAcceptedContent$$();
	}

	private getLatestAcceptedContent$$(): Subscription {
		return this.termsAndConditionsService
			.getLatestAcceptedContent()
			.pipe(
				tap((data) => {
					const latestTermsAndConditionsDocument = this.termsAndConditionsDocumentsHistory[0];
					const fileName = `terminos-y-condiciones-${latestTermsAndConditionsDocument.majorVersion}-${latestTermsAndConditionsDocument.minorVersion}.pdf`;

					this.termsAndConditionsService.downloadPdfFile(data, fileName);
				}),
				takeUntil(this.destroy$)
			)
			.subscribe();
	}
}
